import {gsap} from "../LibrariesImport";
export default class BlockSliderScrollable {
	static init() {
		this.sliders = document.querySelectorAll(".block-slider-scrollable");

		if(!this.sliders) {
			return;
		}

		this.buildSliders();
	}

	static buildSliders() {
		this.sliders.forEach(slider => {
			const stage = slider.querySelector(".swiper-slider-scrollable");
			const prev = slider.querySelector('.prev');
			const next = slider.querySelector('.next');
			const swiper = new Swiper(stage, {
				loop: false,
				grabCursor: true,
				slidesPerView: "auto",
				spaceBetween: 0,
				speed: 500,
				touchEventsTarget: "container",
				navigation: {
					nextEl: next,
					prevEl: prev,
				},
				mousewheel: {
					enabled: true,
					releaseOnEdges: true,
					forceToAxis: true,
				},
			});
		});
	}
}